import './boot.js'
import './services/signinLink.js'   // right after boot's canonical redirect (which must carry the code to fullrun.io), before anything reads the URL
import './services/heroPage.js'    // and the address the landing hero carried, off the bar before analytics starts (PR #63)
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// PWA: register the (minimal, no-precache) service worker in production only —
// registering in dev interferes with Vite HMR. It never caches app assets, so
// it can't serve a stale build. Failures are swallowed.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* non-fatal */ })
  })
}
